import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../../api/axiosInstance";

const TestimonialForm = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);

  const [form, setForm] = useState({
    name: "",
    role: "",
    company: "",
    testimonialText: "",
    profileImage: "",
    companyLogo: "",
    outcomeTag: "",
    rating: 5,
    isFeatured: false,
    isActive: true
  });

  /* ===== LOAD TESTIMONIAL (EDIT) ===== */
  useEffect(() => {
    if (!id) {
      setLoading(false);
      return;
    }

    const load = async () => {
      try {
        const res = await api.get(`/api/testimonials/${id}`);

        const t = res.data;

        // ✅ MAP API → FORM
        setForm({
          name: t.name || "",
          role: t.role || "",
          company: t.company || "",
          testimonialText: t.testimonialText || "",
          profileImage: t.profileImage || "",
          rating: t.rating ?? 5,
          isFeatured: t.isFeatured ?? false,
          isActive: t.isActive ?? true
        });
      } catch (err) {
        alert("Failed to load testimonial");
        navigate("/admin/testimonials");
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [id, navigate]);

  /* ===== SUBMIT ===== */
  const submit = async (e) => {
    e.preventDefault();

    try {
      if (id) {
        await api.put(`/api/testimonials/${id}`, form);
      } else {
        await api.post("/api/testimonials", form);
      }
      navigate("/admin/testimonials");
    } catch (err) {
      alert("Save failed");
      console.error(err);
    }
  };

  if (loading) return <p>Loading...</p>;

  return (
    <form onSubmit={submit} className="max-w-2xl space-y-4">
      <h1 className="text-xl font-bold">
        {id ? "Edit Testimonial" : "Create Testimonial"}
      </h1>

      <input className="w-full border p-2" placeholder="Name"
        value={form.name}
        onChange={(e) => setForm({ ...form, name: e.target.value })}
      />

      <input className="w-full border p-2" placeholder="Role"
        value={form.role}
        onChange={(e) => setForm({ ...form, role: e.target.value })}
      />

      <input className="w-full border p-2" placeholder="Company"
        value={form.company}
        onChange={(e) => setForm({ ...form, company: e.target.value })}
      />

      <input className="w-full border p-2" placeholder="Profile Image URL"
        value={form.profileImage}
        onChange={(e) => setForm({ ...form, profileImage: e.target.value })}
      />
 
      <textarea className="w-full border p-2 h-32"
        placeholder="Testimonial Text"
        value={form.testimonialText}
        onChange={(e) => setForm({ ...form, testimonialText: e.target.value })}
      />

      <input type="number" min="0" max="5"
        className="w-full border p-2"
        value={form.rating}
        onChange={(e) => setForm({ ...form, rating: Number(e.target.value) })}
      />

      <label className="flex gap-2">
        <input type="checkbox"
          checked={form.isFeatured}
          onChange={(e) => setForm({ ...form, isFeatured: e.target.checked })}
        />
        Featured
      </label>

      <label className="flex gap-2">
        <input type="checkbox"
          checked={form.isActive}
          onChange={(e) => setForm({ ...form, isActive: e.target.checked })}
        />
        Active
      </label>

      <button className="bg-green-600 text-white px-4 py-2 rounded">
        Save
      </button>
    </form>
  );
};

export default TestimonialForm;
